import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { IntegratedServicesManagementContent } from './Components/IntegratedServicesManagementContent';

export const IntegratedServicesManagement = (): React.JSX.Element => (
  <Page title={'Integrated Services'} accessKey={'services'} isSearchable={false}>
    <IntegratedServicesManagementContent />
  </Page>
);
